import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import MicrosoftAzureIntegration from "../MicrosoftAzure/MicrosoftAzure";

const IntuneIntegration = () => {
  const [searchParams] = useSearchParams();
  const [guideMode, setGuideMode] = useState(false);

  useEffect(() => {
    if (searchParams.has("viewonly")) {
      setGuideMode(true);
    }
  }, [searchParams]);
  return (
    <MicrosoftAzureIntegration
      integrationName="intune"
      guideMode={guideMode}
    ></MicrosoftAzureIntegration>
  );
};

export default IntuneIntegration;
